import { API_PATENT_SALES_NAME, API_PATENT_TREE, API_PATENT_UNFOLLOW } from "@/configs/Apis";
import { Fetcher as Ajax } from "@/utils/Request";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";

const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    getPatentTree({ commit }: any) {
      return Ajax.queryData(API_PATENT_TREE, {}, "GET", false)
        .then(data => {
          let count = 0;
          function execCount(item: any) {
            if (item && item.children) {
              item.children.forEach((child: any) => {
                count += child.count;
              });
            }
          }
          if (data && data.length) {
            execCount(data[1]);
          }

          const showCount = 10;
          data.forEach((item: any) => {
            if (!item.children) {
              return;
            }
            if (item.children.length <= showCount) {
              item.showData = { data: [].concat(item.children) };
            } else {
              item.showData = {
                index: 0,
                size: showCount,
                data: item.children.slice(0, showCount)
              };
            }
          });

          commit(
            "setPatentTree",
            [
              {
                title: "全部",
                count: count,
                icon: "all-data",
                patentFilter: {}
              }
            ].concat(data)
          );
        })
        .catch(() => {
          commit("setPatentTree", [
            {
              title: "全部",
              count: 0,
              icon: "all-data",
              patentFilter: {}
            }
          ]);
        });
    },
    salesName(store: any, payload: any) {
      return Ajax.saveData(API_PATENT_SALES_NAME, payload, "PUT");
    },
    unfollow(store: any, payload: any) {
      return Ajax.saveData(API_PATENT_UNFOLLOW, payload, "POST");
    }
  },
  mutations: {
    setPatentTree(state: any, data: any) {
      state.patentTree = data;
    }
  }
});

const oldState = newModule.state as () => Object;

newModule.state = () => ({ ...oldState(), patentTree: null });

export default newModule;
